import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiCallingV2Service, API_CONFIG } from '@zayan-erp/shared';
import {
  SelectionSummaryReportData,
  SelectionSummaryReportFilterRequest
} from '../models/dsm-selection-summary-report.models';

@Injectable({
  providedIn: 'root'
})
export class DsmSelectionSummaryReportService {
  #http = inject(ApiCallingV2Service);
  #apiConfig = inject(API_CONFIG);
  baseUrl = this.#apiConfig.baseUrlV2;

  getSelectionSummaryReport(req: SelectionSummaryReportFilterRequest): Observable<SelectionSummaryReportData> {
    return this.#http.postData<SelectionSummaryReportData>(
      `${this.baseUrl}/dsm-reports/selection-summary`,
      { showLoader: false, showMessage: false },
      req
    );
  }

  downloadSelectionSummaryReportPdf(req: SelectionSummaryReportFilterRequest): Observable<void> {
    const filename = `selection_summary_${+new Date()}.pdf`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/selection-summary/pdf`,
      req,
      { showLoader: true, buttonId: 'selection-summary-pdf', showMessage: true },
      filename
    );
  }

  downloadSelectionSummaryReportExcel(req: SelectionSummaryReportFilterRequest): Observable<void> {
    const filename = `selection_summary_${+new Date()}.xlsx`;
    return this.#http.downloadReportFileWithBody(
      `${this.baseUrl}/dsm-reports/selection-summary/excel`,
      req,
      { showLoader: true, buttonId: 'selection-summary-excel', showMessage: true },
      filename
    );
  }
}
